import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class PlatformNoticeAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['list', {
            url: '/admin/announcement/list',
            name: 'list',
            label: '公告列表'
        }],
        ['add',  {
            url: '/admin/announcement/add',
            name: 'add',
            label: '新增公告'
        }],
        ['delete',  {
            url: '/admin/announcement/delete',
            name: 'delete',
            label: '删除公告'
        }],
    ])
    public list(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('list').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public add(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

  }
